import { render, staticRenderFns } from "./PassoDadosCartao.vue?vue&type=template&id=bf44486e"
import script from "./PassoDadosCartao.vue?vue&type=script&lang=js"
export * from "./PassoDadosCartao.vue?vue&type=script&lang=js"
import style0 from "./PassoDadosCartao.vue?vue&type=style&index=0&id=bf44486e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VCard,VCol,VForm,VImg,VRow,VTextField})
